import { render, staticRenderFns } from "./BeTag.vue?vue&type=template&id=13564ad8&scoped=true"
import script from "./BeTag.vue?vue&type=script&lang=js"
export * from "./BeTag.vue?vue&type=script&lang=js"
import style0 from "./BeTag.vue?vue&type=style&index=0&id=13564ad8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13564ad8",
  null
  
)

export default component.exports